import React, { useState } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import ProductSection from './components/ProductSection';
import ModulesSection from './components/ModulesSection';
import StepsSection from './components/StepsSection';
import FinalCTA from './components/FinalCTA';
import Footer from './components/Footer';

function App() {
  const [lang, setLang] = useState('es');

  return (
    <div className="min-h-screen bg-[#EEF4F2] font-sans antialiased">
      <Header lang={lang} setLang={setLang} />
      <Hero lang={lang} />
      <ProductSection lang={lang} />
      <ModulesSection lang={lang} />
      <StepsSection lang={lang} />
      <FinalCTA lang={lang} />
      <Footer lang={lang} />
    </div>
  );
}

export default App;
